import React from "react";
import Card from "components/card";
import { Sparkles } from "lucide-react";

const HyvidPoints = () => {
    return (
        <Card className="text-slate-900 flex flex-col gap-6 rounded-xl border border-purple-200 bg-gradient-to-br from-white to-purple-50/30">
            <div className="pb-6 p-4">
                <div className="flex items-center justify-between mb-3">
                    <div className="p-2 rounded-full bg-gradient-to-br from-emerald-500 to-purple-500">
                        <Sparkles className="w-5 h-5 text-white" />
                    </div>
                    <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 tracking-normal
                        gap-1 transition-[color,box-shadow] overflow-hidden bg-purple-100 dark:bg-purple-900/50 text-purple-700 border-purple-200 text-[9px]"
                    >
                        +150 this month
                    </span>
                </div>
                <p className="text-[12px] text-slate-700 mb-1 tracking-normal">
                    Hyvid Points
                </p>
                <p className="text-[22px] font-bold text-purple-600 mb-0.5">
                    2,450
                </p>
                <p className="text-[10px] text-slate-700 tracking-normal">
                    Rank: Top 15%
                </p>
            </div>
        </Card>
    )
};
export default HyvidPoints;